export class EmptyCollectionsFolderException extends Error {
  name = 'EmptyCollectionsFolderException';
  username: string;

  constructor(username: string) {
    super('Collection folder is empty.');
    this.username = username;
  }
}
